module.exports = __webpack_public_path__ + "static/understand-c408ce1991eb6597394fe43c2b67134c.webp";